import { Box, Typography } from "@mui/material";
import { MainContext } from "../../../../main/context/MainContextProvider";
import { useContext } from "react";

export type PerformanceCardProps = {
    value: string;
    title: string;
    suffix?: string;
    color?: "info" | string;
}

export default function PerformanceCard(props: PerformanceCardProps) {
    const { theme } = useContext(MainContext);

    return (
        <Box sx={{ backgroundColor: props.color === "info" ? "rgba(36, 59, 96, 0.6)" : "#202020b0", borderRadius: "8px", padding: "8px", paddingX: "14px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <Typography sx={{ fontSize: "11px", color: props.color === "info" ? "#78a5cc" : theme.secondaryTextColor, marginBottom: "4px" }}>
                {props.title}
            </Typography>
            <Typography sx={{ fontSize: "18px", fontWeight: "600" }}>
                {props.value}
            </Typography>
            {props.suffix &&
                <Typography sx={{ fontSize: "11px", color: props.color === "info" ? "#78a5cc" : theme.secondaryTextColor }}>
                    {props.suffix}
                </Typography>}
        </Box>
    )
}